import { createFileRoute } from '@tanstack/react-router';

import { ShareLinkFormPage } from '../features/sharing/share-link-form-page';

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/edit',
)({ component: EditShareLinkRoute });

function EditShareLinkRoute() {
  return <ShareLinkFormPage {...Route.useParams()} />;
}
